import styled from "@emotion/styled";
import { darkTheme } from "@avenue-8/sidekick-ui";
import { Prism } from "react-syntax-highlighter";

export const SyntaxHighlighter = styled(Prism)`
  border-radius: 0 !important;
  margin: 0 !important;
  font-size: 0.75rem !important;
  max-height: 20rem;
  overflow-y: auto !important;
  overflow-x: auto !important;
  max-width: 100%;

  code {
    font-size: 0.75rem !important;
    white-space: pre !important;
  }

  &::-webkit-scrollbar {
    width: 6px;
    height: 6px;
  }

  &::-webkit-scrollbar-track {
    background: ${darkTheme.jsonText.button.colors.background};
    border-radius: 0 0 0.5rem 0;
  }

  &::-webkit-scrollbar-thumb {
    background: ${darkTheme.jsonText.button.colors.border};
    border-radius: 3px;
    opacity: 0.5;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: ${darkTheme.jsonText.button.colors.text};
  }

  &::-webkit-scrollbar-corner {
    background: ${darkTheme.jsonText.button.colors.background};
  }
`;
